import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import RestaurantGallery from '../components/RestaurantList/RestaurantGallery'

const Restaurantgallarypage = () => {
  return (
    <div>

        <Navbar/>

        <RestaurantGallery/>

        <Footer/>

    </div>
  )
}

export default Restaurantgallarypage
